export default {
  pricing: {
    title: "Tarifs",
    hero: {
      title: "Un abonnement. Accès total.",
      subtitle: "Commencez gratuitement. Débloquez toute l'expérience sur le web et mobile.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "44,99 $ US pour toute l'année",
      newsletterRenewLine: "Renouvellement à 59,99 $ US/an",
    },
    plans: {
      free: {
        features: [
          "Jeux tendance du jour",
          "Taux de réussite des équipes et joueurs",
          "Journaux de matchs et historique de performance",
        ],
      },
      annual: {
        billingShort: "année",
        billingLong: "annuellement",
        features: [
          "Inclut tout le plan gratuit +",
          "Chaque signal de jeu et l'analyse complète",
          "Alignements partants, impact des blessures et météo",
          "Accès exclusif à tous les parlays",
          "Analyses plus poussées de tous les parlays tendance",
          "Filtres de recherche avancés",
          "Option pour choisir et modifier l'affichage des cotes",
        ],
      },
      monthly: {
        billingShort: "mois",
        billingLong: "mensuellement",
        features: [
          "Inclut tout le plan gratuit +",
          "Chaque signal de jeu et l'analyse complète",
          "Alignements partants, impact des blessures et météo",
          "Accès exclusif à tous les parlays",
          "Analyses plus poussées de tous les parlays tendance",
          "Filtres de recherche avancés",
          "Option pour choisir et modifier l'affichage des cotes",
        ],
      },
    },
    actions: {
      currentPlan: "Votre plan actuel",
      manage: "Gérer",
      upgrade: "Passer au niveau supérieur",
    },
    badges: {
      mostPopular: "Le plus populaire",
      annualSavings: "Économisez jusqu'à 60% avec le plan annuel",
    },
    operators: {
      prefix: "Entièrement intégré avec",
      highlight: "des opérateurs mondiaux",
      suffix: "pour une expérience fluide de la recherche au pari",
    },
    sections: {
      fullPicture: "Voyez le portrait complet avant de parier",
      signals: "Débloquez tous les signaux pour obtenir plus de contexte",
    },
    testimonials: {
      trusted: "Approuvé par<br/>900k parieurs sportifs",
      betslips: "Plus de<br/>1M+ betslips créés",
      previous: "Témoignages précédents",
      next: "Témoignages suivants",
      items: [
        {
          title: "Vraiment la meilleure app conçue que j'ai vue depuis longtemps.",
          description: "Tout est exactement où il faut, chaque sélection fonctionne comme prévu, et l'app est conçue avec beaucoup de soin. Elle est très riche en information, mais reste efficace et bien organisée. Comme passionné de stats, je salue le design de Linemate et la facilité à trouver de bons jeux.",
        },
        {
          title: "La meilleure app de toutes",
          description: "C'est à 100% la meilleure app pour les paris sportifs. Après quelques jours d'essai, j'étais convaincu. Je recommande fortement la version payante pour profiter de tout ce qu'elle offre. Vous ne serez pas déçu.",
        },
        {
          title: "La meilleure",
          description: "J'ai essayé beaucoup d'apps de stats. Linemate est celle vers laquelle je reviens. Elle offre beaucoup gratuitement, ajoute des fonctionnalités sans en retirer, et le plan Plus vaut vraiment le prix. Le support a répondu en 5 minutes. On voit qu'ils veulent être l'app de référence.",
        },
        {
          title: "Agréablement surpris",
          description: "Si vous êtes nouveau et suivez les props aveuglément, les résultats varieront; il faut quand même une stratégie. J'ai téléchargé Linemate après plusieurs parlays ratés de peu, et mon premier parlay de 7 legs a touché. Avec la première semaine gratuite, le prix mensuel en vaut facilement la peine.",
        },
        {
          title: "Super app!",
          description: "Aucune app de paris n'est parfaite, mais celle-ci m'a donné les meilleurs résultats jusqu'ici. Tout repose sur de vraies stats et données. La version gratuite est solide, et l'abonnement est encore meilleur.",
        },
        {
          title: "Une app qui se démarque",
          description: "Une excellente app qui se démarque vraiment, abordable et avec de fortes fonctionnalités pour la recherche. Dans l'ensemble, très beau travail.",
        },
      ],
    },
    comparison: {
      premium: "Annuel/Mensuel",
      included: "Inclus",
      notIncluded: "Non inclus",
    },
    popup: {
      billedAnnually: "Facturé annuellement",
      savePercent: "Économisez {{percent}}%",
      upgradeForJust: "Passez au niveau supérieur pour seulement {{price}}/{{billingPeriod}}",
      dismiss: "Fermer",
    },
  },
};
